import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c48970f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "DoAnswerPage" }
const _hoisted_2 = { class: "doAnswerCart" }

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { listQuestionVoByPageUsingPost } from "@/api/questionController";
import { getAppVoByIdUsingGet } from "@/api/appController";
import { addUserAnswerUsingPost } from "@/api/userAnswerController";
import router from "@/router";
import { generateUserAnswerIdUsingGet } from "@/request/api/userAnswerController";
//答题唯一标识
interface Props {
  appId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DoAnswerPage',
  props: {
    appId: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const id = ref<number>(0);
//表单
const form = {};
//应用
const app = ref<API.AppVO>({});
//所有题目
const questionContent = ref<API.QuestionContentDTO>({});
//答案
const choices = ref<string[]>([]);
//未选答案
const noChoice = ref<number[]>([]);
//是否在加载中
const isLoad = ref(false);

const props = __props;
/**
 * 获取答题唯一标识
 */
const getUserAnswerId = async () => {
  let res: any = await generateUserAnswerIdUsingGet();
  if (res.data.code === 0) {
    id.value = res.data.data;
  } else {
    message.error("获取答题唯一标识失败，" + res.data.message);
  }
};

/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  //获取应用信息
  let appRes = await getAppVoByIdUsingGet({
    id: props.appId,
  });
  if (appRes.data.code === 0 && appRes.data.data) {
    app.value = appRes.data.data as any;
  } else {
    message.error("获取应用信息失败，" + appRes.data.message);
  }
  //获取题目信息
  const questionRes = await listQuestionVoByPageUsingPost({
    appId: props.appId,
    current: 1,
    pageSize: 1,
    sortField: "createTime",
    sortOrder: "descend",
  });
  if (questionRes.data.code === 0 && questionRes.data.data?.records) {
    questionContent.value =
      questionRes.data.data?.records[0].questionContentDTO;
  }
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
  getUserAnswerId();
});

/**
 * 提交题目
 */
const submitQuestion = async () => {
  if (choices.value.length === 0) {
    message.warning("请先选择答案");
    return;
  }
  //判断是否有未选答案
  noChoice.value = [];
  for (let i = 0; i < choices.value.length; i++) {
    if (!choices.value[i]) {
      noChoice.value.push(i + 1);
    }
  }
  if (noChoice.value.length > 0) {
    message.warning("第" + noChoice.value.join(",") + "题未选择答案");
    return;
  }

  isLoad.value = true;
  const response = await addUserAnswerUsingPost({
    choices: choices.value,
    appId: props.appId,
    id: id.value,
  });
  if (response.data.code === 0) {
    await router.push({
      path: `/answer/result/${response.data.data}`,
      replace: true,
    });
  } else {
    message.error("提交失败，" + response.data.message);
  }
  isLoad.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        model: form,
        "label-align": "left",
        "auto-label-width": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_typography_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(app.value.appName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { style: {"margin":"-20px 0 -10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_typography_paragraph, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(app.value.appDesc), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_divider),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionContent.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_typography_title, { heading: 5 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(index + 1) + "、" + _toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_form_item, { style: {"margin-top":"-20px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_group, {
                    modelValue: choices.value[index],
                    "onUpdate:modelValue": ($event: any) => ((choices.value[index]) = $event),
                    direction: "vertical"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option) => {
                        return (_openBlock(), _createBlock(_component_a_radio, {
                          value: option.key,
                          key: option.key
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_typography_text, { style: {"font-size":"16px"} }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(option.key) + "." + _toDisplayString(option.value), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_divider)
            ]))
          }), 128)),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_space, { size: "large" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    style: {"width":"100px"},
                    loading: isLoad.value,
                    onClick: submitQuestion
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(isLoad.value != true ? "提交答案" : "正在分析中"), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})